import React from "react";
import styles from "./ConversionFeatures.module.css";

const ConversionFeatures = () => {
  return (
    <div className={styles.conversionFeatures}>
      <h3>Core capabilities:</h3>
      <div className={styles.conversionGrid}>
        <div className={styles.conversionCard}>
          <div className={styles.conversionIcon}>🖼️→🅹</div>
          <h4>Image to JPG</h4>
          <p>
            Convert any image to jpeg format that is high quality for photos or
            realistic images. Use the quality settings to find a good balance of
            image size and quality.
          </p>
          <ul className={styles.conversionBenefits}>
            <li>Best for photos and images that are complicated.</li>
            <li>Compression is adjustable (1-100 quality).</li>
            <li>Automatically remove transparency.</li>
          </ul>
        </div>

        <div className={styles.conversionCard}>
          <div className={styles.conversionIcon}>🖼️→🅿</div>
          <h4>Image to PNG</h4>
          <p>
            Convert to PNG for lossless compression and alpha channel support.
            Best for logos, graphics, or images needing transparency.
          </p>
          <ul className={styles.conversionBenefits}>
            <li>Keep transparency and sharp edges</li>
            <li>Lossless compression to choose from</li>
            <li>Supports 24-bit color with alpha channel</li>
          </ul>
        </div>

        <div className={styles.conversionCard}>
          <div className={styles.conversionIcon}>🖼️→🆆</div>
          <h4>Image to WEBP</h4>
          <p>
            Convert to the modern WEBP format to use a superior compression. Get
            files that are 25-35% smaller than JPEG without losing quality and
            can also have transparency as an option.
          </p>
          <ul className={styles.conversionBenefits}>
            <li>Next generation compression technology</li>
            <li>Transparent optional support</li>
            <li>Good for optimizing for web performance</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ConversionFeatures;
